<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-card-text>
        <template v-if="mode === 'edit'">
          <v-stepper v-model="step" alt-labels elevation="0">
            <v-stepper-header
              color="#193D6E"
              class="mt-2 mb-2"
              elevation="0"
              style="
                justify-content: center;
                align-items: center;
                box-shadow: none;
              "
            >
              <v-stepper-step
                :complete="step > 1"
                step="1"
                color="#193D6E"
              ></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :complete="step > 2"
                step="2"
                color="#193D6E"
              ></v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- Paso 1: Actualizar correo -->
              <v-stepper-content step="1" elevation="0" class="pt-0">
                <div class="text-center mb-4">
                  <div class="step-title">{{ texts.settings.emailTwoFactor.editEmailTitle }}</div> 
                  <div class="step-subtitle mb-0">
                    {{ texts.settings.emailTwoFactor.editEmailSubtitle }}
                  </div>
                </div>
                <v-form ref="editForm" v-model="editValid" class="py-5" autocomplete="off">
                  <v-text-field
                    v-model="emailLocal"
                    :label="texts.settings.emailTwoFactor.currentEmail"
                    disabled
                    outlined
                    class="mb-2"
                    style="border-radius: 10px"
                    type="email"
                    autocomplete="off"
                  />
                  <v-text-field
                    v-model="newEmail"
                    :rules="emailRules"
                    :label="texts.settings.emailTwoFactor.newEmail"
                    required
                    outlined
                    class="mb-2"
                    style="border-radius: 10px"
                    type="email"
                    autocomplete="new-email"
                  />
                </v-form>
                <div class="d-flex justify-space-around pb-2">
                  <v-btn
                    rounded
                    outlined
                    color="#0075B8"
                    @click="close"
                    elevation="3"
                    min-width="150px"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    >{{ texts.settings.emailTwoFactor.cancel }}</v-btn
                  >
                  <v-btn
                    rounded
                    color="#0075B8"
                    :loading="isFormLoading"
                    :disabled="!editValid || newEmail === emailLocal"
                    min-width="150px"
                    @click="sendOtp"
                    elevation="3"
                    style="
                      border-radius: 100px;
                      text-transform: none;
                      color: #fff;
                    "
                    >{{ texts.settings.emailTwoFactor.continue }}</v-btn
                  >
                </div>
              </v-stepper-content>

              <!-- Paso 2: Verificar identidad (OTP) -->
              <v-stepper-content step="2" class="pt-0">
                <div class="text-center mb-4">
                  <div class="step-title">{{ texts.settings.emailTwoFactor.twoFactor.title }}</div> 
                  <div class="step-subtitle mb-6">
                    {{ texts.settings.emailTwoFactor.twoFactor.subtitle }}
                  </div>
                </div>
                <v-form ref="otpForm" v-model="otpValid" autocomplete="off">
                  <v-otp-input
                    v-model="otp"
                    :rules="otpRules"
                    length="6"
                    type="number"
                    color="#193D6E"
                    class="otp-input-centered"
                    autocomplete="one-time-code"
                  />
                </v-form>
                <div class="d-flex justify-space-between mt-6 mb-6">
                  <v-btn
                    rounded
                    outlined
                    color="#0075B8"
                    @click="step = 1"
                    elevation="3"
                    min-width="150px"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    >{{ texts.settings.emailTwoFactor.twoFactor.cancel }}</v-btn
                  >
                  <v-btn
                    rounded
                    color="#0075B8"
                    :loading="isFormLoading"
                    :disabled="!otpValid"
                    min-width="150px"
                    @click="validateOtp"
                    elevation="3"
                    style="
                      border-radius: 100px;
                      text-transform: none;
                      color: #fff;
                    "
                    >{{ texts.settings.emailTwoFactor.twoFactor.validate }}</v-btn
                  >
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>
        <template v-else>
          <v-container class="pt-10">
            <div class="text-center mb-10">
              <div class="step-title">{{ texts.settings.emailTwoFactor.configureEmailTitle }}</div>
              <div class="step-subtitle mb-0">
                {{ texts.settings.emailTwoFactor.configureEmailSubtitle }}
              </div>
            </div>
          </v-container>
          <v-form ref="editForm" v-model="editValid" class="py-5" autocomplete="off">
            <v-text-field
              v-model="newEmail"
              :rules="emailRules"
              :label="texts.settings.emailTwoFactor.configureEmailEmail"
              required
              outlined
              class="mb-2"
              type="email"
              autocomplete="new-email"
            />
            <v-text-field
              v-model="password"
              :rules="passwordRules"
              :label="texts.settings.emailTwoFactor.configureEmailPassword"
              required
              outlined
              class="mb-2"
              type="password"
              autocomplete="new-password"
            />
          </v-form>
          <div class="d-flex justify-space-around pb-2">
            <v-btn
              rounded
              outlined
              color="#0075B8"
              @click="close"
              elevation="3"
              min-width="150px"
              style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
              >{{ texts.settings.emailTwoFactor.cancel }}</v-btn
            >
            <v-btn
              rounded
              color="#0075B8"
              :loading="isFormLoading"
              :disabled="!editValid"
              min-width="150px"
              @click="sendOtp"
              elevation="3"
              style="border-radius: 100px; text-transform: none; color: #fff"
              >{{ texts.settings.emailTwoFactor.configureEmailSave }}</v-btn
            >
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogEmailTwoFactor",
  props: {
    value: Boolean,
    email: String,
    texts: Object,
    mode: {
      type: String,
      default: "edit", // 'edit' o 'setEmail'
      validator: (v) => ["edit", "setEmail"].includes(v)
    }
  },
  data() {
    return {
      emailLocal: this.email,
      newEmail: "",
      password: "",
      otp: "",
      step: 1,
      editValid: false,
      otpValid: false,
      isFormLoading: false,
      emailRules: [
        (v) => !!v || "El correo es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "El correo debe ser válido"
      ],
      passwordRules: [
        (v) => !!v || "La contraseña es obligatoria",
        (v) => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres",
        //(v) => /[!@#$%^&*(),.?":{}|<>]/.test(v) || "La contraseña debe tener al menos un carácter especial"
      ],
      otpRules: [
        (v) => !!v || "El código es obligatorio",
        (v) => /^\d{6}$/.test(v) || "El código debe tener 6 dígitos"
      ]
    };
  },
  watch: {
    email(val) {
      this.emailLocal = val;
    },
    value(val) {
      if (val) {
        this.resetForm();
      }
    },
    mode(val) {
      this.resetForm();
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.resetForm();
    },
    resetForm() {
      this.emailLocal = this.email;
      this.newEmail = "";
      this.password = "";
      this.otp = "";
      this.step = 1;
      this.editValid = false;
      this.otpValid = false;
      this.isFormLoading = false;
    },
    sendOtp() {
      if (!this.$refs.editForm.validate()) return;
      if (this.mode === "edit") {
        if (this.newEmail === this.emailLocal) {
          this.$parent.mixError(
            "El nuevo correo debe ser diferente al actual.",
            400
          );
          return;
        }
        this.isFormLoading = true;
        DB.get(`${URI}/api/v1/${this.$store.state.language}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
          .then((response) => {
            if (!response.data.success) {
              this.$parent.mixError(response.data.message, response.status);
            } else {
              this.step = 2;
            }
          })
          .catch((error) => {
            this.$parent.mixError(
              error.response.data.message,
              error.response.status
            );
          })
          .finally(() => {
            this.isFormLoading = false;
          });
      } else if (this.mode === "setEmail") {
        // Enviar OTP al nuevo correo, requiere contraseña
        this.isFormLoading = true;
        const payload = {
          sEmail: this.newEmail,
          sPassword: this.password
        };
        DB.post(
          `${URI}/api/v1/${this.$store.state.language}/authenticator/saveEmail`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
          .then((response) => {
            if (!response.data.success) {
              this.$parent.mixError(response.data.message, response.status);
            } else {
              this.$parent.mixSuccess(response.data.message, response.status);
              this.step = 2;
              this.close();
              this.getDataAuth();
            }
          })
          .catch((error) => {
            this.$parent.mixError(
              error.response.data.message,
              error.response.status
            );
          })
          .finally(() => {
            this.isFormLoading = false;
          });
      }
    },
    validateOtp() {
      if (!this.otp || this.otp.length !== 6) return;
      this.isFormLoading = true;
      if (this.mode === "edit") {
        DB.put(
          `${URI}/api/v1/${this.$store.state.language}/authenticator/updateEmail`,
          {
            sEmail: this.newEmail,
            sCode: this.otp
          },
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
          .then((response) => {
            if (!response.data.success) {
              this.$parent.mixError(response.data.message, response.status);
            } else {
              this.$parent.mixSuccess(response.data.message, response.status);
              this.$emit("refresh");
              this.close();
            }
          })
          .catch((error) => {
            this.$parent.mixError(
              error.response.data.message,
              error.response.status
            );
          })
          .finally(() => {
            this.isFormLoading = false;
          });
      } else if (this.mode === "setEmail") {
        // Validar OTP para activar el correo
        const payload = {
          sCode: this.otp
        };
        DB.post(
          `${URI}/api/v1/${this.$store.state.language}/authenticator/verify`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
          .then((response) => {
            if (!response.data.success) {
              this.$parent.mixError(response.data.message, response.status);
            } else {
              this.$parent.mixSuccess(response.data.message, response.status);
              this.$emit("refresh");
              this.close();
            }
          })
          .catch((error) => {
            this.$parent.mixError(
              error.response.data.message,
              error.response.status
            );
          })
          .finally(() => {
            this.isFormLoading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.step-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.step-subtitle {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}
.otp-input-centered {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.v-btn[outlined] {
  border: 1.5px solid #193d6e;
  color: #193d6e;
}
.v-btn {
  min-width: 140px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(25, 61, 110, 0.08);
}
.v-text-field input {
  font-size: 1.1rem;
  padding: 18px 12px;
}
.thin-divider {
  width: 40px;
  margin: 0 8px;
  align-self: center;
}
</style>
